<template>
  <component
    :is="
      creative._type
        ? _.upperFirst(creative._type + 'Preview').replace('WithOutstream', '')
        : ''
    "
    :creative="creative"
  ></component>
</template>

<script>
import { mapState } from "vuex";
import InskinPreview from "@/components/pages/previews/inskin.vue";
import OutstreamPreview from "@/components/pages/previews/outstream.vue";
import PushdownPreview from "@/components/pages/previews/pushdown.vue";
import ParallaxScrollingPreview from "@/components/pages/previews/parallaxScrolling.vue";
import ParallaxScrollingFlipPreview from "@/components/pages/previews/parallaxScrollingFlip.vue";
import ScrollingBoxPreview from "@/components/pages/previews/scrollingBox.vue";
import CarouselPreview from "@/components/pages/previews/carousel.vue";
import BannerPreview from "@/components/pages/previews/banner.vue";
import SpinnerPreview from "@/components/pages/previews/spinner.vue";
import CardsPreview from "@/components/pages/previews/cards.vue";
import RollingCastlePreview from "@/components/pages/previews/rollingCastle.vue";
import SwitchPreview from "@/components/pages/previews/switch.vue";
import MarqueePreview from "@/components/pages/previews/marquee.vue";
import RotatingFerrisWheelPreview from "@/components/pages/previews/rotatingFerrisWheel.vue";
import SwapPreview from "@/components/pages/previews/swap.vue";
import CountDownPreview from "@/components/pages/previews/countDown.vue";
import PostAdPreview from "@/components/pages/previews/postAd.vue";
import DataDrivenPreview from "@/components/pages/previews/dataDriven.vue";

const getAfter30Days = () => {
  let date = new Date();
  date.setDate(date.getDate() + 30);
  let dateString = date.toISOString();
  return dateString;
};

let demoMapping = [
  {
    _type: "banner",
    width: 320,
    height: 480,
    material_type: 0,
    image_url:
      "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
    preview_device: 0,
    preview_type: 7,
    landing_page: "https://www.ucfunnel.com",
  },
  {
    _type: "postAd",
    material_type: 1,
    advertiser_icon:
      "https://cdn.aralego.net/high_impact_creative/postAd/ucfunnel_icon.png",
    content:
      "this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.",
    image_url:
      "https://cdn.aralego.net/high_impact_creative/postAd/ucfunnel_postAd_image.jpeg",
    landing_page: "https://www.ucfunnel.com",
    advertiser_name: "ucfunnel 悠福科技",
  },
  {
    _type: "postAdWithOutstream",
    material_type: 1,
    advertiser_icon:
      "https://cdn.aralego.net/high_impact_creative/postAd/ucfunnel_icon.png",
    content:
      "this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.this is ucfunnel demo page, You can set your content at gallery page.",
    advertiser_name: "ucfunnel 悠福科技",
    landing_page: "https://www.ucfunnel.com",
    vast_xml: `<VAST version='4.0'>
        <Ad id='{{ADSESSION_ID}}'>
            <InLine>
            <AdSystem><![CDATA[ucX]]></AdSystem>
                <Creatives>
                    <Creative>
                        <Linear>
                        <Duration>00:00:30</Duration>
                        <VideoClicks>
                        <ClickThrough><![CDATA[https://www.ucfunnel.com]]></ClickThrough>
                        </VideoClicks>
                        <MediaFiles>
                            <MediaFile width='320' height='480' type='video/mp4' bitrate='97' delivery='progressive'><![CDATA[http://cdn.aralego.net/high_impact_creative/video/ffmpeg-bannerWithOutstream.mp4]]></MediaFile>
                        </MediaFiles>
                        </Linear>
                    </Creative>
                </Creatives>
            </InLine>
        </Ad>
    </VAST>`,
  },
  {
    _type: "bannerWithOutstream",
    vertical_align: "center",
    vertical_padding: 0,
    horizontal_align: "center",
    horizontal_padding: 71,
    video_width: 320,
    video_height: 480,
    width: 320,
    height: 480,
    preview_type: 2,
    preview_device: 1,
    material_type: 0,
    image_url:
      "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
    landing_page: "https://www.ucfunnel.com",
    vast_xml: `<VAST version='4.0'>
        <Ad id='{{ADSESSION_ID}}'>
            <InLine>
            <AdSystem><![CDATA[ucX]]></AdSystem>
                <Creatives>
                    <Creative>
                        <Linear>
                        <Duration>00:00:30</Duration>
                        <VideoClicks>
                        <ClickThrough><![CDATA[https://www.ucfunnel.com]]></ClickThrough>
                        </VideoClicks>
                        <MediaFiles>
                            <MediaFile width='320' height='480' type='video/mp4' bitrate='97' delivery='progressive'><![CDATA[http://cdn.aralego.net/high_impact_creative/video/ffmpeg-bannerWithOutstream.mp4]]></MediaFile>
                        </MediaFiles>
                        </Linear>
                    </Creative>
                </Creatives>
            </InLine>
        </Ad>
    </VAST>`,
  },
  {
    _type: "cards",
    cards: [
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/card_footer/1.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/card_footer/2.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/card_footer/3.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/card_footer/4.png",
        landing_page: "https://www.ucfunnel.com",
      },
    ],
  },
  {
    _type: "carousel",
    carousels: [
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/carousel_ad_01.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/carousel_ad_02.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/carousel_ad_03.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/carousel_ad_04.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/carousel_ad_05.png",
        landing_page: "https://www.ucfunnel.com",
      },
    ],
  },
  {
    _type: "inskin",
    content_width: 80,
    top_image_height: 500,
    bottom_image_height: 100,
    top_image_url:
      "https://cdn.aralego.net/high_impact_creative/inskin/top.png",
    bottom_image_url:
      "https://cdn.aralego.net/high_impact_creative/inskin/bottom.png",
    left_image_url:
      "https://cdn.aralego.net/high_impact_creative/inskin/left.png",
    right_image_url:
      "https://cdn.aralego.net/high_impact_creative/inskin/right.png",
    landing_page: "https://www.ucfunnel.com",
  },
  {
    _type: "marquee",
    width: 320,
    height: 100,
    images: [
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/marquee/marquee001.gif",
      },
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/marquee/marquee002.png",
      },
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/marquee/marquee003.jpg",
      },
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/marquee/marquee004.png",
      },
    ],
    landing_page: "https://www.ucfunnel.com",
    marqueeType: 0,
    closeBtnType: 0,
  },
  {
    "_type": "rotatingFerrisWheel",
    "images": [
      {
        "urlFront": "https://cdn.aralego.net/rich_media/dev/d8505e5fda4cd7d89b79976d363ebb5c133eff857ebb6bd2af1376d1a2f1288a.png",
        "urlBack": "https://cdn.aralego.net/rich_media/dev/379ff1426427050adacbe6239b6294ede56cfeb58f5715be7d426ff739b68c92.png",
        "landing_page": "https://www.ucfunnel.com/"
      },
      {
        "urlFront": "https://cdn.aralego.net/rich_media/dev/86db29d685ac6e0342e9c3c9429751472d330fdddfeaf5385ebe93af69276312.png",
        "urlBack": "https://cdn.aralego.net/rich_media/dev/4416b9549a514f2720b55b22b354c069d64e42817975b80f9c48f641864223dc.png",
        "landing_page": "https://www.cna.com.tw/"
      },
      {
        "urlFront": "https://cdn.aralego.net/rich_media/dev/2536f1237b6492f40e0abe35c9a5cfa9d1cac2f4ef527ae3e31f3ac7767a0980.png",
        "urlBack": "https://cdn.aralego.net/rich_media/dev/e97ff882ded88d9b5d1b2e8d12c941b17412af5c57a5265cba3017e921702391.png",
        "landing_page": "https://www.google.com/"
      }
    ],
    "useSameLandingPage": true,
    "landing_page": "https://www.ucfunnel.com/",
  },
  {
    _type: "outstream",
    vast_xml: `<VAST version='4.0'>
      <Ad id='{{ADSESSION_ID}}'>
      <InLine><AdSystem><![CDATA[ucX]]></AdSystem>
      <Creatives><Creative><Linear skipoffset='00:00:10'><Duration>00:02:05</Duration><TrackingEvents><Tracking event='start'><![CDATA[{{VIDEO_START}}]]></Tracking><Tracking event='progress' offset='00:00:05'><![CDATA[{{VIDEO_IMPRESSION_5S}}]]></Tracking><Tracking event='firstQuartile'><![CDATA[{{VIDEO_FIRST_QUARTILE}}?sec=31]]></Tracking><Tracking event='midpoint'><![CDATA[{{VIDEO_MIDPOINT}}?sec=62]]></Tracking><Tracking event='thirdQuartile'><![CDATA[{{VIDEO_THIRD_QUARTILE}}?sec=93]]></Tracking>\n        <Tracking event='complete'><![CDATA[{{VIDEO_COMPLETE}}?sec=125]]></Tracking><Tracking event='skip'><![CDATA[{{VIDEO_SKIP}}]]></Tracking><Tracking event='viewable_impression'><![CDATA[{{THIRD_PARTY_IMPRESSION_MACRO}}]]></Tracking><Tracking event='viewable_impression'><![CDATA[{{IMPRESSION_TRACKING}}]]></Tracking><Tracking event='viewable_impression'><![CDATA[{{VIDEO_IMPRESSION}}]]></Tracking></TrackingEvents><VideoClicks><ClickTracking><![CDATA[{{VIDEO_CLICK}}]]></ClickTracking><ClickTracking><![CDATA[{{CLICK_TRACKING}}]]></ClickTracking><ClickTracking><![CDATA[{{THIRD_PARTY_CLICK_MACRO}}]]></ClickTracking><ClickThrough><![CDATA[https://www.ucfunnel.com]]></ClickThrough></VideoClicks><MediaFiles><MediaFile width='640' height='360' type='video/mp4' bitrate='24' delivery='progressive'><![CDATA[https://cdn.aralego.net/high_impact_creative/video/ffmpeg-outstream.mp4]]></MediaFile></MediaFiles></Linear></Creative></Creatives></InLine></Ad></VAST>`,
  },
  {
    _type: "parallaxScrolling",
    vertical_padding: 0,
    images: [
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
        material_type: 0,
      },
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
        material_type: 0,
      },
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
        material_type: 0,
      },
    ],
    landing_page: "https://www.ucfunnel.com",
  },
  {
    _type: "parallaxScrollingWithOutstream",
    vast_xml: `<VAST version='4.0'>
      <Ad id='{{ADSESSION_ID}}'>
        <InLine>
          <AdSystem><![CDATA[ucX]]></AdSystem>
          <Creatives>
            <Creative>
              <Linear>
                <Duration>00:00:30</Duration>
                <TrackingEvents>
                  <Tracking event='viewable_impression'><![CDATA[{{VIDEO_IMPRESSION}}]]></Tracking>
            <Tracking event='viewable_impression'><![CDATA[{{IMPRESSION_TRACKING}}]]></Tracking>
            <Tracking event='viewable_impression'><![CDATA[{{THIRD_PARTY_IMPRESSION_MACRO}}]]></Tracking>
            <Tracking event='start'><![CDATA[{{VIDEO_START}}]]></Tracking>
            <Tracking event='progress' offset='00:00:05'><![CDATA[{{VIDEO_IMPRESSION_5S}}]]></Tracking>
            <Tracking event='firstQuartile'><![CDATA[{{VIDEO_FIRST_QUARTILE}}?sec=7]]></Tracking>
            <Tracking event='midpoint'><![CDATA[{{VIDEO_MIDPOINT}}?sec=15]]></Tracking>
            <Tracking event='thirdQuartile'><![CDATA[{{VIDEO_THIRD_QUARTILE}}?sec=22]]></Tracking>
            <Tracking event='complete'><![CDATA[{{VIDEO_COMPLETE}}?sec=30]]></Tracking>
            <Tracking event='skip'><![CDATA[{{VIDEO_SKIP}}]]></Tracking>
                </TrackingEvents>
                <VideoClicks>
                  <ClickTracking><![CDATA[{{VIDEO_CLICK}}]]></ClickTracking>
            <ClickTracking><![CDATA[{{CLICK_TRACKING}}]]></ClickTracking>
            <ClickTracking><![CDATA[{{THIRD_PARTY_CLICK_MACRO}}]]></ClickTracking><ClickThrough><![CDATA[https://www.ucfunnel.com]]></ClickThrough>
                </VideoClicks>
                <MediaFiles>
                  <MediaFile width='320' height='180' type='video/mp4' bitrate='97' delivery='progressive'><![CDATA[https://cdn.aralego.net/high_impact_creative/video/ffmpeg-bannerWithOutstream.mp4]]></MediaFile>
                </MediaFiles>
              </Linear>
            </Creative>
          </Creatives>
        </InLine>
      </Ad>
    </VAST>`,
    vertical_padding: 0,
    images: [
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
        material_type: 0,
      },
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
        material_type: 0,
      },
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
        material_type: 0,
      },
    ],
    video_index: 1,
    landing_page: "https://www.ucfunnel.com/",
  },
  {
    _type: "parallaxScrollingFlip",
    vast_xml: `<VAST version='4.0'>
      <Ad id='{{ADSESSION_ID}}'>
        <InLine>
          <AdSystem><![CDATA[ucX]]></AdSystem>
          <Creatives>
            <Creative>
              <Linear>
                <Duration>00:00:30</Duration>
                <TrackingEvents>
                  <Tracking event='viewable_impression'><![CDATA[{{VIDEO_IMPRESSION}}]]></Tracking>
            <Tracking event='viewable_impression'><![CDATA[{{IMPRESSION_TRACKING}}]]></Tracking>
            <Tracking event='viewable_impression'><![CDATA[{{THIRD_PARTY_IMPRESSION_MACRO}}]]></Tracking>
            <Tracking event='start'><![CDATA[{{VIDEO_START}}]]></Tracking>
            <Tracking event='progress' offset='00:00:05'><![CDATA[{{VIDEO_IMPRESSION_5S}}]]></Tracking>
            <Tracking event='firstQuartile'><![CDATA[{{VIDEO_FIRST_QUARTILE}}?sec=7]]></Tracking>
            <Tracking event='midpoint'><![CDATA[{{VIDEO_MIDPOINT}}?sec=15]]></Tracking>
            <Tracking event='thirdQuartile'><![CDATA[{{VIDEO_THIRD_QUARTILE}}?sec=22]]></Tracking>
            <Tracking event='complete'><![CDATA[{{VIDEO_COMPLETE}}?sec=30]]></Tracking>
            <Tracking event='skip'><![CDATA[{{VIDEO_SKIP}}]]></Tracking>
                </TrackingEvents>
                <VideoClicks>
                  <ClickTracking><![CDATA[{{VIDEO_CLICK}}]]></ClickTracking>
            <ClickTracking><![CDATA[{{CLICK_TRACKING}}]]></ClickTracking>
            <ClickTracking><![CDATA[{{THIRD_PARTY_CLICK_MACRO}}]]></ClickTracking><ClickThrough><![CDATA[https://www.ucfunnel.com]]></ClickThrough>
                </VideoClicks>
                <MediaFiles>
                  <MediaFile width='320' height='180' type='video/mp4' bitrate='97' delivery='progressive'><![CDATA[https://cdn.aralego.net/high_impact_creative/video/ffmpeg-bannerWithOutstream.mp4]]></MediaFile>
                </MediaFiles>
              </Linear>
            </Creative>
          </Creatives>
        </InLine>
      </Ad>
    </VAST>`,
    vertical_padding: 0,
    images: [
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
        material_type: 0,
      },
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
        material_type: 0,
      },
      {
        url:
          "https://cdn.aralego.net/high_impact_creative/parallaxscroll/parallaxscroll.png",
        material_type: 0,
      },
    ],
    video_index: 1,
    landing_page: "https://www.ucfunnel.com/",
    "video_width": 320,
    "video_height": 180,
    "use_fullscreen": true,
  },
  {
    _type: "pushdown",
    material_type: 0,
    landing_page: "https://www.ucfunnel.com",
    initial_image_url:
      "https://cdn.aralego.net/high_impact_creative/pushdown/pushdown_banner_250.png",
    expanded_image_url:
      "https://cdn.aralego.net/high_impact_creative/pushdown/pushdown_expand.png",
  },
  {
    _type: "pushdownWithOutstream",
    material_type: 0,
    landing_page: "https://www.ucfunnel.com",
    initial_image_url:
      "https://cdn.aralego.net/high_impact_creative/pushdown/pushdown_banner_250.png",
    expanded_image_url:
      "https://cdn.aralego.net/high_impact_creative/pushdown/pushdown_expand.png",
    vast_xml: `<VAST version='4.0'>
      <Ad id='{{ADSESSION_ID}}'>
        <InLine>
          <AdSystem><![CDATA[ucX]]></AdSystem>
          <Creatives>
            <Creative>
              <Linear>
                <Duration>00:00:30</Duration>
                <TrackingEvents>
                  <Tracking event='start'><![CDATA[{{VIDEO_START}}]]></Tracking>
            <Tracking event='progress' offset='00:00:05'><![CDATA[{{VIDEO_IMPRESSION_5S}}]]></Tracking>
            <Tracking event='firstQuartile'><![CDATA[{{VIDEO_FIRST_QUARTILE}}?sec=7]]></Tracking>
            <Tracking event='midpoint'><![CDATA[{{VIDEO_MIDPOINT}}?sec=15]]></Tracking>
            <Tracking event='thirdQuartile'><![CDATA[{{VIDEO_THIRD_QUARTILE}}?sec=22]]></Tracking>
            <Tracking event='complete'><![CDATA[{{VIDEO_COMPLETE}}?sec=30]]></Tracking>
            <Tracking event='skip'><![CDATA[{{VIDEO_SKIP}}]]></Tracking>
                <Tracking event='viewable_impression'><![CDATA[{{THIRD_PARTY_IMPRESSION_MACRO}}]]></Tracking><Tracking event='viewable_impression'><![CDATA[{{IMPRESSION_TRACKING}}]]></Tracking><Tracking event='viewable_impression'><![CDATA[{{VIDEO_IMPRESSION}}]]></Tracking></TrackingEvents>
                <VideoClicks>
                  <ClickTracking><![CDATA[{{VIDEO_CLICK}}]]></ClickTracking>
                <ClickTracking><![CDATA[{{CLICK_TRACKING}}]]></ClickTracking>
                <ClickTracking><![CDATA[{{THIRD_PARTY_CLICK_MACRO}}]]></ClickTracking><ClickThrough><![CDATA[https://www.ucfunnel.com/]]></ClickThrough>
                </VideoClicks>
                <MediaFiles>
                  <MediaFile width='970' height='250' type='video/mp4' bitrate='94' delivery='progressive'><![CDATA[http://cdn.aralego.net/high_impact_creative/video/ffmpeg-pushdownWithOutstream.mp4]]></MediaFile>
                </MediaFiles>
              </Linear>
            </Creative>
          </Creatives>
        </InLine>
      </Ad>
    </VAST>`,
    initial_video_width: 970,
    initial_video_height: 250,
    expanded_video_width: 970,
    expanded_video_height: 500,
    expanded_horizontal_padding: 0,
    expanded_vertical_padding: 0,
    initial_horizontal_padding: 0,
    initial_vertical_padding: 65,
  },
  {
    _type: "rollingCastle",
    cards: [
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/revolver/1.png",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/revolver/2.png",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/revolver/3.png",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/revolver/4.png",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/revolver/5.png",
      },
    ],
    background_image_url:
      "https://cdn.aralego.net/high_impact_creative/revolver/Rolling_Castle_bg.png",
    banners: [
      {
        is_custom: false,
        images: [],
        type: "video",
        landing_page: "https://www.ucfunnel.com",
        vast_url: "",
        vast_xml: `<VAST version='4.0'>
            <Ad id='{{ADSESSION_ID}}'>
            <InLine>
            <AdSystem><![CDATA[ucX]]></AdSystem>
            <Creatives><Creative>
            <Linear><Duration>00:00:30</Duration><TrackingEvents><Tracking event='start'><![CDATA[{{VIDEO_START}}]]></Tracking>
            <Tracking event='progress' offset='00:00:05'><![CDATA[{{VIDEO_IMPRESSION_5S}}]]></Tracking><Tracking event='firstQuartile'><![CDATA[{{VIDEO_FIRST_QUARTILE}}?sec=7]]></Tracking>
            <Tracking event='midpoint'><![CDATA[{{VIDEO_MIDPOINT}}?sec=15]]></Tracking><Tracking event='thirdQuartile'><![CDATA[{{VIDEO_THIRD_QUARTILE}}?sec=22]]></Tracking>
            <Tracking event='complete'><![CDATA[{{VIDEO_COMPLETE}}?sec=30]]></Tracking>
            <Tracking event='skip'><![CDATA[{{VIDEO_SKIP}}]]></Tracking>
            <Tracking event='viewable_impression'><![CDATA[{{THIRD_PARTY_IMPRESSION_MACRO}}]]></Tracking>
            <Tracking event='viewable_impression'><![CDATA[{{IMPRESSION_TRACKING}}]]></Tracking>
            <Tracking event='viewable_impression'><![CDATA[{{VIDEO_IMPRESSION}}]]></Tracking></TrackingEvents>
            <VideoClicks>
            <ClickTracking><![CDATA[{{VIDEO_CLICK}}]]></ClickTracking>
            <ClickTracking><![CDATA[{{CLICK_TRACKING}}]]></ClickTracking>
            <ClickTracking><![CDATA[{{THIRD_PARTY_CLICK_MACRO}}]]></ClickTracking>
            <ClickThrough><![CDATA[https://cdn.aralego.net/high_impact_creative/revolver/cake-bg.png]]></ClickThrough>
            </VideoClicks>
            <MediaFiles>
            <MediaFile width='640' height='1138' type='video/mp4' bitrate='97' delivery='progressive'><![CDATA[https://cdn.aralego.net/high_impact_creative/video/ffmpeg-bannerWithOutstream.mp4]]></MediaFile>
            </MediaFiles>
            </Linear>
            </Creative>
            </Creatives>
            </InLine>
            </Ad>
          </VAST>`,
      },
      {
        is_custom: false,
        images: [
          {
            is_float: false,
            vertical_align: "center",
            horizontal_align: "center",
            type: "bg",
            url:
              "https://cdn.aralego.net/high_impact_creative/revolver/man-bg.png",
          },
        ],
        type: "image",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        is_custom: false,
        images: [
          {
            is_float: false,
            vertical_align: "center",
            horizontal_align: "center",
            type: "bg",
            url:
              "https://cdn.aralego.net/high_impact_creative/revolver/yellow-bg.png",
          },
          {
            is_float: false,
            vertical_align: "center",
            horizontal_align: "center",
            type: "fg",
            url:
              "https://cdn.aralego.net/high_impact_creative/revolver/yellow.png",
            width: 100,
            vertical_padding: 0,
            horizontal_padding: 0,
          },
        ],
        type: "image",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        is_custom: false,
        images: [
          {
            is_float: false,
            vertical_align: "center",
            horizontal_align: "center",
            type: "bg",
            url:
              "https://cdn.aralego.net/high_impact_creative/revolver/travel-bg.png",
          },
          {
            is_float: false,
            vertical_align: "center",
            horizontal_align: "center",
            type: "fg",
            url:
              "https://cdn.aralego.net/high_impact_creative/revolver/travel.png",
            width: 100,
            vertical_padding: 0,
            horizontal_padding: 0,
          },
        ],
        type: "image",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        is_custom: false,
        images: [
          {
            is_float: false,
            vertical_align: "center",
            horizontal_align: "center",
            type: "bg",
            url:
              "https://cdn.aralego.net/high_impact_creative/revolver/woman-bg.png",
          },
          {
            is_float: false,
            vertical_align: "center",
            horizontal_align: "center",
            type: "fg",
            url:
              "https://cdn.aralego.net/high_impact_creative/revolver/woman.png",
            width: 100,
            vertical_padding: 0,
            horizontal_padding: 0,
          },
        ],
        type: "image",
        landing_page: "https://www.ucfunnel.com",
      },
    ],
  },
  {
    _type: "scrollingBox",
    scrolling_boxes: [
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/scrollingbox_ad_01.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/scrollingbox_ad_02.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/scrollingbox_ad_03.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/carousel_ad_04.png",
        landing_page: "https://www.ucfunnel.com",
      },
    ],
  },
  {
    _type: "spinner",
    top: {
      landing_page: "https://www.ucfunnel.com",
      click_tracking: "",
      images: [
        {
          use_shake_center: false,
          url:
            "https://cdn.aralego.net/high_impact_creative/spin_footer/top-bg.png",
        },
        {
          use_shake_center: true,
          url:
            "https://cdn.aralego.net/high_impact_creative/spin_footer/top.png",
          shake_center: {
            x: 66,
            y: 27,
          },
        },
      ],
    },
    bottom: {
      landing_page: "https://www.ucfunnel.com",
      click_tracking: "",
      images: [
        {
          use_shake_center: false,
          url:
            "https://cdn.aralego.net/high_impact_creative/spin_footer/bottom-bg.png",
        },
        {
          use_shake_center: true,
          url:
            "https://cdn.aralego.net/high_impact_creative/spin_footer/bottom.png",
          shake_center: {
            x: 37,
            y: 83,
          },
        },
      ],
    },
    left: {
      landing_page: "https://www.ucfunnel.com",
      click_tracking: "",
      images: [
        {
          use_shake_center: false,
          url:
            "https://cdn.aralego.net/high_impact_creative/spin_footer/left-bg.png",
        },
        {
          use_shake_center: true,
          url:
            "https://cdn.aralego.net/high_impact_creative/spin_footer/left.png",
          shake_center: {
            x: 18,
            y: 42,
          },
        },
      ],
    },
    right: {
      landing_page: "https://www.ucfunnel.com",
      click_tracking: "",
      images: [
        {
          use_shake_center: false,
          url:
            "https://cdn.aralego.net/high_impact_creative/spin_footer/right-bg.png",
        },
        {
          use_shake_center: true,
          url:
            "https://cdn.aralego.net/high_impact_creative/spin_footer/right.png",
          shake_center: {
            x: 82,
            y: 61,
          },
        },
      ],
    },
  },
  {
    _type: "swap",
    swap: [
      {
        image_url: "https://cdn.aralego.net/high_impact_creative/swap/top.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/swap/bottom.png",
        landing_page: "https://www.ucfunnel.com",
      },
    ],
  },
  {
    _type: "switch",
    blinds: [
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/switch/switch_001.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/switch/switch_002.png",
        landing_page: "https://www.ucfunnel.com",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/switch/switch_003.gif",
        landing_page: "https://www.ucfunnel.com",
      },
    ],
  },
  {
    _type: "countDown",
    landing_page: "https://www.ucfunnel.com",
    top_layer_image_url:
      "https://cdn.aralego.net/high_impact_creative/countdown/countdown_top_layer.png",
    images: [
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/countdown/countdown01.png",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/countdown/countdown02.png",
      },
      {
        image_url:
          "https://cdn.aralego.net/high_impact_creative/countdown/countdown03.png",
      },
    ],
    ultimate_landing_page: "https://www.ucfunnel.com",
    ultimate_image_url:
      "https://cdn.aralego.net/high_impact_creative/countdown/countdown_top_layer.png",
    date_time: getAfter30Days(), // after 30 days,
    width: 320,
    height: 480,
  },
  {
    _type: "dataDriven",
    material_type: 0,
    width: 300,
    height: 390,
    conditions: [
      {
        horizontal_align: "center",
        horizontal_padding: 0,
        html_url: "",
        humidity_display: false,
        humidity_max: null,
        humidity_min: null,
        image_url:
          "http://cdn.aralego.net/high_impact_creative/data_driven_creative01.png",
        landing_page: "https://www.ucfunnel.com",
        name: "Default",
        pm25_display: false,
        pm25_max: null,
        pm25_min: null,
        temperature_display: false,
        temperature_max: null,
        temperature_min: null,
        temperature_unit: CONSTANT.TEMPERATURE_TYPE.C,
        time_duration: null,
        time_duration_display: false,
        vertical_align: "center",
        vertical_padding: 0,
        weather: null,
        weather_display: false,
      },
      {
        horizontal_align: "center",
        horizontal_padding: 0,
        html_url: "",
        humidity_display: false,
        humidity_max: null,
        humidity_min: null,
        image_url:
          "http://cdn.aralego.net/high_impact_creative/data_driven_sunny.png",
        landing_page: "https://www.ucfunnel.com",
        name: "Default",
        pm25_display: false,
        pm25_max: null,
        pm25_min: null,
        temperature_display: false,
        temperature_max: null,
        temperature_min: null,
        temperature_unit: CONSTANT.TEMPERATURE_TYPE.C,
        time_duration: null,
        time_duration_display: false,
        vertical_align: "center",
        vertical_padding: 0,
        weather: "Sunny",
        weather_display: false,
      },
      {
        horizontal_align: "center",
        horizontal_padding: 0,
        html_url: "",
        humidity_display: false,
        humidity_max: null,
        humidity_min: null,
        image_url:
          "http://cdn.aralego.net/high_impact_creative/data_driven_cloudy.png",
        landing_page: "https://www.ucfunnel.com",
        name: "Default",
        pm25_display: false,
        pm25_max: null,
        pm25_min: null,
        temperature_display: false,
        temperature_max: null,
        temperature_min: null,
        temperature_unit: CONSTANT.TEMPERATURE_TYPE.C,
        time_duration: null,
        time_duration_display: false,
        vertical_align: "center",
        vertical_padding: 0,
        weather: "Cloudy",
        weather_display: false,
      },
      {
        horizontal_align: "center",
        horizontal_padding: 0,
        html_url: "",
        humidity_display: false,
        humidity_max: null,
        humidity_min: null,
        image_url:
          "http://cdn.aralego.net/high_impact_creative/data_driven_rainy.png",
        landing_page: "https://www.ucfunnel.com",
        name: "Default",
        pm25_display: false,
        pm25_max: null,
        pm25_min: null,
        temperature_display: false,
        temperature_max: null,
        temperature_min: null,
        temperature_unit: CONSTANT.TEMPERATURE_TYPE.C,
        time_duration: null,
        time_duration_display: false,
        vertical_align: "center",
        vertical_padding: 0,
        weather: "Rainy",
        weather_display: false,
      },
    ],
  },
];

demoMapping = _.keyBy(demoMapping, "_type");

export default {
  data() {
    return {
      creativeId: this.$route.params.creativeId,
      creative: {},
      notification: null,
    };
  },
  components: {
    InskinPreview,
    OutstreamPreview,
    PushdownPreview,
    ParallaxScrollingPreview,
    ParallaxScrollingFlipPreview,
    ScrollingBoxPreview,
    CarouselPreview,
    BannerPreview,
    SpinnerPreview,
    CardsPreview,
    RollingCastlePreview,
    SwitchPreview,
    MarqueePreview,
    RotatingFerrisWheelPreview,
    SwapPreview,
    CountDownPreview,
    PostAdPreview,
    DataDrivenPreview,
  },
  computed: {
    ...mapState({
      typeMapping: (state) => state.creative.typeMapping,
    }),
  },
  async created() {
    if (this.creativeId === "temp") {
      let command = {};
      command.type = "temp";
      window.opener.postMessage(command, "*");
    } else if (this.creativeId === "demo") {
      const type = this.$route.query._type;
      document.title = type;
      this.creative = demoMapping[type];
    } else {
      await store.dispatch("creative/getCreativeById", this.creativeId);
      this.creative = store.getters["creative/getCreativeById"](
        this.creativeId
      );
      document.title = this.creative.name;
    }
    window.addEventListener("message", this.messageHandler, false);
  },
  watch: {
    "creative.preview_device"(newPreviewDevice) {
      if (newPreviewDevice === CONSTANT.PREVIEW_DEVICE.MOBILE)
        this.setMobileCSS();
    },
  },
  methods: {
    setMobileCSS() {
      let style = document.createElement("style");
      style.type = "text/css";
      style.innerHTML = `
        html {
          margin: 0px auto !important;
        }
        @media only screen and (min-width: 768px){
          html, body, body > div, .mask {
            max-width: 400px !important;
          }
          body > div, .mask{
            left: auto !important;
          }
        }`;
      document.head.appendChild(style);
    },
    messageHandler(e) {
      switch (e.data.type) {
        case "initial":
          const frame = document.querySelector("iframe");
          if (frame) {
            let command = {};

            command.type = "initialCreative";
            command.creative = this.creative;
            frame.contentWindow.postMessage(command, "*");
          }
          break;
        case "tempCreative":
          this.creative = e.data.creative;
          document.title = "(temp) " + this.creative.name;

          if (this.notification) this.notification.close();
          this.notification = this.$notify({
            title: `${this.typeMapping[this.creative._type]} Temp Preview`,
            message: this.creative.name,
            type: "warning",
            position: "top-right",
            customClass: "custom",
            duration: 0,
            showClose: true,
          });
          break;
      }
    },
  },
};
</script>
<style lang="sass">
.el-notification.custom
  height: 100px
  .el-notification__title
    font-size: 20px
  .el-notification__content
    font-size: 16px
    margin: 10px 0 0
</style>
